<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: "App",
  head() {
    const canonicalBaseUrl = process.env.VUE_APP_SITE_URL || "https://allcare.com.cy"
    const isIndexableBuild = process.env.VUE_APP_IS_INDEXABLE === "true"
    const normalizedPath = this.$route.path === "/" ? "/" : this.$route.path.replace(/\/+$/, "")
    const canonicalHref = `${canonicalBaseUrl}${normalizedPath}`
    const shouldNoindex = !isIndexableBuild ||
        this.$route.name === "login" ||
        this.$route.name === "lost" ||
        this.$route.name === "error" ||
        this.$route.matched.some((routeRecord) => routeRecord.meta.requiresAuth || routeRecord.meta.role)

    return {
      title: "AllCare Cyprus",
      // Greek uppercase styling needs lang="el" to handle tonos correctly.
      htmlAttrs: {
        lang: this.$store.state.locale === "gr" ? "el" : (this.$store.state.locale || "en"),
      },
      meta: [
        {
          name: "robots",
          content: shouldNoindex
              ? "noindex, nofollow"
              : "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: canonicalHref,
        },
      ],
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
}
</style>
<style src="../node_modules/vue-multiselect/dist/vue-multiselect.css"></style>
